import { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { CheckCircle2 } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const nav = useNavigate();

  useEffect(() => {
    if (!sessionId) return;
    let tries = 0;
    const iv = setInterval(async () => {
      tries += 1;
      try {
        const r = await api.get(`/payments/status/${sessionId}`);
        if (r.data.payment_status === "paid") {
          setStatus("paid");
          clearInterval(iv);
          setTimeout(() => nav("/dashboard"), 1500);
        }
      } catch (_e) { /* noop */ }
      if (tries > 20) {
        clearInterval(iv);
        setStatus("timeout");
      }
    }, 2000);
    return () => clearInterval(iv);
  }, [sessionId, nav]);

  return (
    <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-24 min-h-[70vh] flex items-center justify-center" data-testid="payment-success">
      <div className="panel p-10 max-w-md w-full text-center">
        <CheckCircle2 className="w-14 h-14 text-emerald-400 mx-auto" />
        <h1 className="font-display text-3xl font-bold text-white mt-4">
          {status === "paid" ? "Ödeme başarılı!" : status === "timeout" ? "Doğrulama zaman aşımı" : "Ödeme doğrulanıyor..."}
        </h1>
        <p className="text-slate-400 mt-3">
          {status === "paid" ? "Siparişiniz üretim sırasına alındı. Panelinize yönlendiriliyorsunuz." : "Bir kaç saniye içinde otomatik yönlendirileceksiniz."}
        </p>
        <Link to="/dashboard" className="btn-cyan mt-6 inline-block">Panele Git</Link>
      </div>
    </main>
  );
}
